/**
 * @file Shared Calendar modal feedback helpers.
 */

import { openConfirmationModal } from "../../shared/ui/confirmationModal.js";
import { escapeHTML } from "../../shared/utils/contentUtils.js";

function getMessageText(message, fallback) {
    return String(message || fallback || "");
}

/**
 * Shows a Calendar acknowledgement modal for completed actions.
 * @param {string} title Modal title.
 * @param {string} message Modal message.
 * @returns {void}
 */
export function showCalendarConfirmationModal(title, message) {
    openConfirmationModal(
        title,
        escapeHTML(getMessageText(message, "Calendar action completed.")),
        async () => {},
        false,
        "OK",
        null,
        "",
        "Cancel",
        {
            actionsLayout: "right",
            hideCancel: true,
        },
    );
}

/**
 * Shows a Calendar error modal for failed actions.
 * @param {string} title Modal title.
 * @param {Error|string|null|undefined} error Error source.
 * @param {string} fallback Fallback message.
 * @returns {void}
 */
export function showCalendarErrorModal(title, error, fallback) {
    const message = typeof error === "string" ?
        error :
        error?.message;
    openConfirmationModal(
        title,
        escapeHTML(getMessageText(message, fallback)),
        async () => {},
        false,
        "OK",
        null,
        "",
        "Cancel",
        {
            actionsLayout: "right",
            hideCancel: true,
        },
    );
}
